import React, { useEffect, useState } from "react";
import Confirm from "./Confirm";
import FormGroup from "../theme/form-group/FormGroup";

export function RenameConfirm<T>({
    item,
    title,
    onHide,
    onRename,
    fullTitle,
    text,
}: {
    item: T | undefined | null;
    title: string | undefined | null
    onHide: () => void;
    onRename: (item: T, newName: string) => void;
    fullTitle?: string,
    text?: string,
}) {
    const [name, setName] = useState(text);

    useEffect(() => {
        setName(text ?? "");
    }, [text]);

    return (
        <Confirm
            title={fullTitle || `Rename ${title}`}
            shouldShow={item != null}
            confirmText="Rename"
            closeText="Cancel"
            closeVariant="outline-gray"
            confirmVariant="primary"
            dialogClassName="centered-container-md"
            onHide={() => onHide()}
            onConfirm={() => {
                onRename(item as T, name ?? "");
                onHide();
            }}
        >
            <FormGroup
                type="text"
                label="Rename View"
                autoFocus={item != null}
                variant="default"
                value={name}
                onChange={event => setName(event.target.value)}
            />
        </Confirm>
    );
}

RenameConfirm.defaultProps = {
    fullTitle: undefined,
    text: undefined,
};

export default function useRenameConfirm<T>(
    onEdit: (item: T, newName: string) => void,
    onExtractText: ((item: T) => string | null | undefined),
    title?: string,
) {
    const [editing, setEditing] = useState<T>();

    const text = (editing != null ? onExtractText(editing) : undefined);
    return {
        setEditing,
        element: (
            <RenameConfirm
                title={title ?? text}
                item={editing}
                onHide={() => setEditing(undefined)}
                onRename={onEdit}
                fullTitle={title}
                text={text ?? ""}
            />
        ),
    };
}
